export const ACTIVITY_TYPES = {
  online: { label: "Online", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  in_presenza: { label: "In presenza", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  telefonica: { label: "Telefonica", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  amministrativa: { label: "Amministrativa", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const fmtHours = (h) => `${Number(h || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })} h`;
